var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinicTemplateWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    width: 18,
    height: 18,
    transform: "translate(346.023 285.059)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Clinic_Templates_White_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clinic_Templates_White_1",
    "data-name": "Clinic Templates White \\u2013 1",
    clipPath: "url(#clip-Clinic_Templates_White_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3816",
    "data-name": "Group 3816",
    transform: "translate(-346.023 -285.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3815",
    "data-name": "Group 3815",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_5958",
    "data-name": "Path 5958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3803",
    "data-name": "Group 3803"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6265",
    "data-name": "Path 6265",
    d: "M354.629,286.591v-.053a.492.492,0,1,0-.985,0l-.8.053a1.308,1.308,0,0,1,1.294-1.346,1.294,1.294,0,0,1,1.293,1.293Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_5959",
    "data-name": "Path 5959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3804",
    "data-name": "Group 3804"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6266",
    "data-name": "Path 6266",
    d: "M352.565,289.441a.722.722,0,0,1-.722-.722v-1.882h0a.65.65,0,0,1,.649-.649h3.16a.65.65,0,0,1,.65.649v1.882a.722.722,0,0,1-1.438.1.743.743,0,0,0-.635-.674.728.728,0,0,0-.813.629.737.737,0,0,1-.72.67Zm.079-2.453v1.567a1.525,1.525,0,0,1,2.856-.379v-1.188Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_5960",
    "data-name": "Path 5960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3805",
    "data-name": "Group 3805"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6267",
    "data-name": "Path 6267",
    d: "M358.8,302.85h-9.317a1.273,1.273,0,0,1-1.272-1.271V288.215a1.273,1.273,0,0,1,1.272-1.271h2.765v.8h-2.765a.472.472,0,0,0-.471.471v13.364a.472.472,0,0,0,.47.471H358.8a.471.471,0,0,0,.472-.471V288.215a.472.472,0,0,0-.471-.471h-2.9v-.8h2.9a1.274,1.274,0,0,1,1.272,1.271v13.364A1.273,1.273,0,0,1,358.8,302.85Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_5961",
    "data-name": "Path 5961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3806",
    "data-name": "Group 3806"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6268",
    "data-name": "Path 6268",
    d: "M356.63,301.561H349.5V288.236h2.444v.8H350.3v11.725h6l1.679-1.679V289.038h-1.644v-.8h2.444v11.175Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_5962",
    "data-name": "Path 5962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3807",
    "data-name": "Group 3807"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6269",
    "data-name": "Path 6269",
    d: "M352.133,295.626l-.792-.792.566-.565.208.208.741-.785.582.549Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line_630",
    "data-name": "Line 630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3808",
    "data-name": "Group 3808"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_703",
    "data-name": "Rectangle 703",
    width: 1.726,
    height: 0.8,
    transform: "translate(351.396 291.753) rotate(-45.049)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line_631",
    "data-name": "Line 631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3809",
    "data-name": "Group 3809"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_704",
    "data-name": "Rectangle 704",
    width: 0.8,
    height: 1.726,
    transform: "translate(351.396 291.097) rotate(-45)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line_632",
    "data-name": "Line 632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3810",
    "data-name": "Group 3810"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_705",
    "data-name": "Rectangle 705",
    width: 1.726,
    height: 0.8,
    transform: "translate(351.396 298.045) rotate(-45.049)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line_633",
    "data-name": "Line 633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3811",
    "data-name": "Group 3811"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_706",
    "data-name": "Rectangle 706",
    width: 0.8,
    height: 1.726,
    transform: "translate(351.396 297.389) rotate(-45)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line_634",
    "data-name": "Line 634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3812",
    "data-name": "Group 3812"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_707",
    "data-name": "Rectangle 707",
    width: 3.534,
    height: 0.8,
    transform: "translate(353.771 291.636)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line_635",
    "data-name": "Line 635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3813",
    "data-name": "Group 3813"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_708",
    "data-name": "Rectangle 708",
    width: 3.534,
    height: 0.8,
    transform: "translate(353.771 294.725)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_5963",
    "data-name": "Path 5963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3814",
    "data-name": "Group 3814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6270",
    "data-name": "Path 6270",
    d: "M356.055,300.782a.4.4,0,0,1-.4-.4v-1.944H357.6a.4.4,0,1,1,0,.8h-1.144v1.145A.4.4,0,0,1,356.055,300.782Z",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicTemplateWhite);
export default __webpack_public_path__ + "static/media/clinic-template-white.244d66cd448fec55ba1a0cd6320d2ebe.svg";
export { ForwardRef as ReactComponent };